export default __webpack_public_path__ + "static/media/groupMembersRed.b0adf1db.svg";